import React, { useState } from "react"
import { connect } from "react-redux"
import styles from "./ConsentPopup.module.css"
import { submitUserConsent } from "../../api/consent/consent.service"
import { LinkButton, Submit } from "../../components/button/buttons"
import IMAGES from "../../assets/images/images"
import { openAlertPopup } from "../../redux/actions/Alert/alert.action"
import { USER_TYPE } from "../../utils/constants/userConstants"
import { logOut } from "../../authActions/authActions"

const ConsentPopup = ({ isOpen, ...props }) => {
  const [isSubmit, setIsSubmit] = useState(false)
  const [seeMore, setSeeMore] = useState(false)
  const userType = props?.myRights?.userType
  const isConsentCaptured = props?.myRights?.consentData

  if (userType != USER_TYPE.CUSTOMER) return null

  if (userType == USER_TYPE.CUSTOMER && isConsentCaptured?.consentGiven)
    return null

  const handleClick = () => {
    setIsSubmit(true)
    submitUserConsent()
      .then((res) => {
        setIsSubmit(false)
        // props.openAlertPopup({
        //     message: "Your consent has been recorded. Thank you for your response.",
        //     image: IMAGES.success
        //   });
        window.location.reload()
        // setTimeout(() => {
        //     window.location.reload();
        // }, 3000); // 3,000 milliseconds = 3 seconds
      })
      .catch((error) => {
        setIsSubmit(false)
        // props.openAlertPopup({
        //     message: "An error occurred while capturing your consent. Please try again",
        //     image: IMAGES.error
        // });
      })
  }

  const signInWithDifferentUser = () => {
    logOut()
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <div className={styles.header}>
          <div className={styles.title}>Disclaimer</div>
        </div>
        <div className={styles.note}>
          <div className={styles.disclaimer}>
            By accessing and managing user accounts on IPXplore on behalf of
            your team, customer acknowledges fair usage of this platform.
          </div>
          {/* {!seeMore && (
            <div
              className={styles.toggle}
              onClick={() => {
                setSeeMore(true)
              }}
            >
              See More...
            </div>
          )}
          {seeMore && (
            <ul>
              <li className={styles.textnote}>
                Customer has the appropriate authority and consent to create,
                modify, or deactivate user profiles.
              </li>
              <li className={styles.textnote}>
                Customers are responsible for maintaining the confidentiality
                and security of login credentials associated with each user.
              </li>
              <li className={styles.textnote}>
                Customer organization assumes all responsibility for actions
                taken under its user accounts, including compliance with
                applicable terms of service, privacy policies, and usage
                guidelines.
              </li>
              <li className={styles.textnote}>
                Vodafone is not liable for any loss, misuse, or unauthorized
                access resulting from your team's management of user accounts.
              </li>
              <li className={styles.textnote}>
                If at any time you suspect unauthorized activity, we recommend
                contacting our support team immediately.
              </li>
            </ul>
          )}
          {seeMore && (
            <div
              className={styles.toggle}
              onClick={() => {
                setSeeMore(false)
              }}
            >
              See Less...
            </div>
          )} */}
        </div>
        <div className={styles.btnContainer}>
          <Submit
            style={styles.submit}
            title="Yes, I Accept"
            id="submit"
            isSubmitting={isSubmit}
            loaderstyle={styles.loader}
            // disabled={!seeMore}
            onClick={handleClick}
          />
        </div>
        <LinkButton
          className={styles.resetLink}
          title={"Click here to sign in with a different user"}
          onClick={signInWithDifferentUser}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    myRights: state.myRights.myRights
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openAlertPopup: (payload) => {
      return dispatch(openAlertPopup(payload))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsentPopup)